var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31.5px",
    height: "31.5px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slozka-list-190415",
    transform: "translate(-1392.000000, -224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1393.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pridat-cestu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,40 C8.9725,40 0,31.0275 0,20 C0,8.9725 8.9725,0 20,0 C31.0275,0 40,8.9725 40,20 C40,31.0275 31.0275,40 20,40 Z",
    id: "Path-Copy-2",
    stroke: "currentColor",
    strokeWidth: 1.11999991,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,19 L20.875,19 L20.875,10.75 C20.875,10.33525 20.539,10 20.125,10 C19.711,10 19.375,10.33525 19.375,10.75 L19.375,19 L10.75,19 C10.336,19 10,19.33525 10,19.75 C10,20.16475 10.336,20.5 10.75,20.5 L19.375,20.5 L19.375,29.5 C19.375,29.91475 19.711,30.25 20.125,30.25 C20.539,30.25 20.875,29.91475 20.875,29.5 L20.875,20.5 L29.5,20.5 C29.914,20.5 30.25,20.16475 30.25,19.75 C30.25,19.33525 29.914,19 29.5,19 Z",
    id: "Path-Copy-3",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconRound);
export default __webpack_public_path__ + "static/media/PlusIconRound.55b494123089538fb5b11f453155e5ed.svg";
export { ForwardRef as ReactComponent };